import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Radio, Gavel, Gift, Heart, ArrowRight, X, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const STEPS = [
  {
    icon: Radio,
    title: "Welcome to SouqStream 👋",
    body: "The live shopping marketplace for the Muslim community. Sellers go live, you watch, chat and shop in real time.",
  },
  {
    icon: Gavel,
    title: "Watch, bid & buy live",
    body: "Jump into a live show to win items in fast auctions, grab buy-it-now deals, and enter free giveaways — all as it happens.",
  },
  {
    icon: Heart,
    title: "Follow your favourite sellers",
    body: "Tap Follow on any seller so you get a heads-up the moment they go live. Never miss a drop.",
  },
  {
    icon: Sparkles,
    title: "Ready to explore?",
    body: "Head to Discover to see who's live right now and start shopping.",
  },
];

export function OnboardingTour() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [i, setI] = useState(0);

  const key = user?.user_id ? `ss_onboard:${user.user_id}` : null;

  useEffect(() => {
    if (key && localStorage.getItem(key) === "pending") setOpen(true);
  }, [key]);

  const done = () => {
    if (key) localStorage.setItem(key, "done");
    setOpen(false);
  };
  const finishAndExplore = () => { done(); navigate("/"); };

  if (!open) return null;
  const step = STEPS[i];
  const Icon = step.icon;
  const last = i === STEPS.length - 1;

  return (
    <div className="ss-modal-back" style={{ zIndex: 60 }} data-testid="onboarding-tour">
      <div className="ss-modal fade-up" style={{ maxWidth: 460, textAlign: "center", position: "relative" }} onClick={(e) => e.stopPropagation()}>
        <button className="disc-search" style={{ position: "absolute", top: 14, right: 14, width: 34, height: 34 }} onClick={done} data-testid="onboarding-skip" title="Skip">
          <X size={18} />
        </button>

        <div style={{ width: 76, height: 76, borderRadius: 20, background: "var(--brand)", display: "grid", placeItems: "center", margin: "8px auto 18px", boxShadow: "0 10px 30px rgba(12,74,56,.35)" }}>
          <Icon size={34} style={{ color: "var(--gold)" }} />
        </div>

        <h2 style={{ fontSize: 24, fontWeight: 800 }} data-testid="onboarding-title">{step.title}</h2>
        <p className="ss-muted" style={{ fontSize: 15, lineHeight: 1.7, marginTop: 10 }}>{step.body}</p>

        <div style={{ display: "flex", justifyContent: "center", gap: 7, margin: "22px 0" }}>
          {STEPS.map((_, n) => (
            <span key={n} onClick={() => setI(n)} style={{ width: n === i ? 22 : 8, height: 8, borderRadius: 999, background: n === i ? "var(--brand)" : "var(--line, #d9d4c7)", transition: "width .25s, background .25s", cursor: "pointer" }} />
          ))}
        </div>

        <div style={{ display: "flex", gap: 10 }}>
          {i > 0 && (
            <button className="ss-btn ss-btn-ghost" style={{ flex: 1 }} onClick={() => setI((n) => n - 1)} data-testid="onboarding-back">Back</button>
          )}
          {last ? (
            <button className="ss-btn ss-btn-primary" style={{ flex: 2 }} onClick={finishAndExplore} data-testid="onboarding-explore">
              Explore live shows <ArrowRight size={16} />
            </button>
          ) : (
            <button className="ss-btn ss-btn-primary" style={{ flex: 2 }} onClick={() => setI((n) => n + 1)} data-testid="onboarding-next">
              Next <ArrowRight size={16} />
            </button>
          )}
        </div>

        {!last && (
          <button onClick={done} className="ss-muted" style={{ background: "none", border: "none", cursor: "pointer", marginTop: 14, fontSize: 13 }} data-testid="onboarding-skip-link">Skip for now</button>
        )}
      </div>
    </div>
  );
}
